<template>
  <div>
    <div class="bottom-border common-padding-bottom common-padding-top">
      <div class="common-letter-spacing font-weight-bold font-16">{{payType}}</div>
      <router-link tag="div" v-for="(item,index) in dataList" :to="{path: item.url}" v-bind:key="index" class="common-padding-top-1 common-padding-left-1 color-black-1">>
        <span class="common-padding-left-0-5 font-14 cursor-pointer">{{item.name}}</span></router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SideBar',
  props: {
    dataList: {
      type: Array,
      default: () => []
    },
    payType: {
      type: String,
      default: '相关接口'
    }
  },
  created () {
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/interface/components/SideBar.vue